import type { Page } from "puppeteer-core";

export async function closePage(page: Page | undefined): Promise<void> {
  if (!page || page.isClosed()) {
    return;
  }

  await page.close();
}
